module.exports = __webpack_public_path__ + "static/uni_morehouse-e928cc591a3f0e419148d1713d030879.png";